import { useMutation } from '@tanstack/react-query';
import { ForgotPasswordService } from '../services/ForgotPasswordService';
import type {
  IResetPasswordRequest,
  TResetPasswordResponse,
} from '../types/ForgotPassword';

export const useResetPassword = () =>
  useMutation<TResetPasswordResponse, unknown, IResetPasswordRequest>({
    mutationFn: (payload) => ForgotPasswordService.resetPassword(payload),
  });
